
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import UserContext from './Context/UserContext';
import api from './api';

import {
    Box,
    Paper,
    Typography,
    TextField,
    Button,
    Alert,
    IconButton
} from '@mui/material';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Login1 = () => {

    const [updateValue, setUpdateValue] = useState({
        email: "",
        password: ""
    });

    const [message, setMessage] = useState("");

    const navigate = useNavigate();

    const { setToken } = useContext(UserContext);

    useEffect(() => {
        let localToken = localStorage.getItem("token");

        if (localToken) {
            navigate("/rooms");
        }
    }, [navigate]);

    function updateUser(e) {
        const key = e.target.name;

        setUpdateValue({
            ...updateValue,
            [key]: e.target.value
        });
    }

    async function setValues(event) {
        event.preventDefault();

        setMessage("");

        if (!updateValue.email || !updateValue.password) {
            setMessage("Please fill all the details");
            return;
        }

        try {
            const res = await api.post("/auth/generateToken", {
                email: updateValue.email,
                password: updateValue.password
            });

            setUpdateValue({
                email: "",
                password: ""
            });

            setToken(res.data.token);

            // Store JWT token in localStorage
            localStorage.setItem(
                "token",
                JSON.stringify(res.data.token)
            );

            alert("Login Successful");

            navigate("/");

            console.log(res.data.message);

        } catch (e) {
            console.log(e.response?.data);

            setMessage(
                e.response?.data?.error || "Login failed. Please try again."
            );
        }
    }

    return (

        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#f5f5f5",
                padding: 2
            }}
        >

            <Paper
                elevation={4}
                sx={{
                    width: "100%",
                    maxWidth: 420,
                    padding: 4,
                    borderRadius: 3,
                    position: "relative"
                }}
            >

                {/* Back Button */}
                <IconButton
                    onClick={() => navigate("/")}
                    sx={{
                        position: "absolute",
                        top: 12,
                        left: 12
                    }}
                >
                    <ArrowBackIcon />
                </IconButton>

                <Box
                    component="form"
                    onSubmit={setValues}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        mt: 3
                    }}
                >

                    <Typography
                        variant="h4"
                        textAlign="center"
                        fontWeight="bold"
                    >
                        Login
                    </Typography>

                    {/* Error Message */}
                    {message && (
                        <Alert severity="error">
                            {message}
                        </Alert>
                    )}

                    {/* Email */}
                    <TextField
                        label="Email"
                        type="email"
                        name="email"
                        placeholder="Enter Email"
                        value={updateValue.email}
                        onChange={updateUser}
                        fullWidth
                    />

                    {/* Password */}
                    <TextField
                        label="Password"
                        type="password"
                        name="password"
                        placeholder="Enter Password"
                        value={updateValue.password}
                        onChange={updateUser}
                        fullWidth
                    />

                    {/* Login Button */}
                    <Button
                        type="submit"
                        variant="contained"
                        size="large"
                        fullWidth
                    >
                        Login
                    </Button>

                </Box>

            </Paper>

        </Box>
    );
};

export default Login1;
